import React from 'react'

import { Box, IconButton, Paper, Tooltip, Typography } from '@material-ui/core'
import { Download as DownloadIcon, File as FileIcon } from 'react-feather'

import useStyles from './styles'

const FileRow = ({ file, index, onDownload }) => {
  const classes = useStyles()

  return (
    <Paper variant="outlined" className={classes.fileRow}>
      <Box display="flex" alignItems="center" flex={1}>
        <FileIcon size={18} className={classes.fileIcon} />
        <Typography className={classes.fileName}>
          {file.name || `Arquivo ${index + 1}`}
        </Typography>
      </Box>
      {file.url && (
        <Tooltip title="Baixar">
          <IconButton size="small" onClick={() => onDownload(file, index)}>
            <DownloadIcon size={16} />
          </IconButton>
        </Tooltip>
      )}
    </Paper>
  )
}

export default FileRow
